<template>
    <div class="useWallet">
        <Header ref="header" :title="title" :titleRight="titleRight" @backPage="onBack" @submit="details"></Header>
        <div class="cashOut" v-show="!bankShow">
            <div class="bank p32 icon" @click="bankShow=true">
                <div class="bLeft">
                    <img src="../../../../assets/img/b2b/bank.png" alt="">
                </div>
                <div class="bRight">
                    <div class="title f32">{{selectBank.bankName}}({{selectBank.bankAccountNumber&&selectBank.bankAccountNumber.slice(-4)}})</div>
                    <div class="content f24">{{selectBank.remark}}</div>
                </div>
            </div>
            <div class="cashInput mtop20">
                <div class="input borderBot">
                    <div class="inputLeft">¥</div>
                    <div class="inputRight"><input type="number" v-model="withdrawAmount" placeholder="请输入提现金额"></div>
                    <div class="colFF7A45"><span @click="withdrawAmount = balance">全部提现</span></div>
                </div>
                <div class="money">
                    <div class="mLeft col000 f26">
                        <span>提现收取{{ getFee }}的手续费</span>
                    </div>
                    <div class="mRight col8E8E93 f26">
                        可提现余额：<span v-text="balance"></span>元
                        <!--<span @click="onMark" class="weng"></span>-->
                    </div>
                    <!-- <div class="mRight colFF7A45" @click="withdrawAmount = balance">
                        全部提现
                    </div> -->
                </div>
            </div>
            <!-- <div class="buttom f32 hide" :class="{'show': withdrawAmount>=100}" @click="onCash">
                提现
            </div> -->
            <div class="buttom f32 hide show" @click="onCash">
                提现
            </div>
        </div>
        <div class="bankList" v-show="bankShow">
            <div class="bank p32 borderBot" v-for="item in bankcardWithdrawList" @click="selectBankOpt(item)" :key="item.bankCardId">
                <div class="bLeft">
                    <img src="../../../../assets/img/b2b/bank.png" alt="">
                </div>
                <div class="bRight">
                    <div class="title f32">{{item.bankName}}({{item.bankAccountNumber.slice(-4)}})</div>
                    <div class="content f24">{{item.remark}}</div>
                </div>
            </div>
        </div>
        <van-dialog
                v-model="showDialog"
                :title="dialogTitle"
                show-cancel-button
                :closeOnClickOverlay="false"
                confirm-button-color="#FF7A45"
                cancel-button-color="#666666"
                :before-close="closeDialog"
        >
            <div class="dialogBox">
                <div class="head">
                    <div class="title">到账金额</div>
                    <div class="arrivalPrice">¥{{ receivedAmount }}</div>
                    <div class="price">收取手续费 ¥{{ serviceFee }}</div>
                </div>
                <div class="dialogInput">
                    <input type="tel" class="dialogCode f32 col000" placeholder="请输入验证码" maxlength="6" v-model="smsCode">
                    <div class="codeBtn countdown" v-if="showCount">{{count}}s</div>
                    <div class="codeBtn getCodeCount" v-else @click="getCodeAgin">重新获取</div>
                </div>
                <div class="diologText">验证码已经发{{ dialogPhone | phoneHide }}</div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import Header from '../../../common/header'
// import { getPayCenter, getCashOut, getPhone, confirmCash, getAccount } from '../api/index'
import { getBankcardWithdraw, postWithdraw, postCashOutSendSms, postCashOutVerifySms, getFeeRate, getFeeCalculation } from '../../../b2b/api/api.js'
import { Toast, Indicator } from 'mint-ui'
import { mapMutations, mapActions, mapGetters } from 'vuex'
export default {
    name: 'useWallet',
    components: {
        Header
    },
    data () {
        return {
            selectBank: {
                bankAccountNumber: '',
                bankAccountType: '',
                bankCardId: '',
                bankName: '',
                bindingId: '',
                remark: ''
            },
            balance: '',
            getFee: '',
            dialogTitle: '',
            dialogPhone: '',
            showDialog: false,
            smsCode: '',
            showCount: true,
            count: '',
            title: '钱包余额提现',
            titleRight: '',
            show: true,
            timer: null,
            payMent: '',
            phone: '',
            userInfo: '',
            withdrawAmount: '',
            myBankOrderNo: '',
            msgCode: '',
            getAccount: '',
            userType: 11,
            companyCode: '',
            receivedAmount: '',
            serviceFee: '',
            bankShow: false
        }
    },
    watch: {
        withdrawAmount (newVal, oldVal) {
            if (parseFloat(newVal) > parseFloat(this.balance)) {
                this.withdrawAmount = this.balance
            } else if (parseFloat(newVal) < 0) {
                this.withdrawAmount = 0
            } else if ((newVal).toString().indexOf('.') > 0) {
                this.withdrawAmount = newVal.toString().match(/^\d*(\.?\d{0,2})/g)[0]
            }
        }
    },
    computed: {
        ...mapGetters(['bankcardWithdrawList'])
    },
    methods: {
        ...mapActions(['setBuried']),
        ...mapMutations({
            setMoney: 'SAVE_MONEY'
        }),
        async getBankinfo () {
            const { companyCode } = this.userInfo
            Indicator.open()
            const { data: { balance, bankCards } } = await getBankcardWithdraw({ companyCode })
            this.selectBank = {
                ...bankCards[0]
            }
            this.balance = balance
        },
        async getBankList () {
            const { companyCode } = this.userInfo
            await this.$store.dispatch('getBankcardWithdrawListAct', { companyCode })
            Indicator.close()
        },
        async onCash () {
            if (this.withdrawAmount < 100) {
                Toast({
                    message: '提现金额不能小于100',
                    duration: 2000
                })
                return
            }
            // if (this.withdrawAmount >= 100) {
            //     const { data } = await postCashOutSendSms({ bankCardId: this.selectBank.bankCardId })
            //     this.dialogPhone = data.toString()
            //     clearInterval(this.countInterver)
            //     this.countInterver = null
            //     this.showDialog = true
            //     this.showCount = true
            //     this.smsCode = ''
            //     this.count = 10
            //     this.countInterver = setInterval(() => {
            //         if (this.count > 0) {
            //             this.count--
            //         } else {
            //             this.showCount = false
            //             clearInterval(this.countInterver)
            //             this.countInterver = null
            //         }
            //     }, 1000)
            // } else {
            //     Toast({
            //         message: '提现金额不能小于100',
            //         duration: 2000
            //     })
            // }
            // 服务费计算
            const feeData = await getFeeCalculation({ amount: this.withdrawAmount, companyCode: this.userInfo.companyCode })
            this.receivedAmount = feeData.data.receivedAmount
            this.serviceFee = feeData.data.serviceFee
            const { data } = await postCashOutSendSms({ bankCardId: this.selectBank.bankCardId })
            this.dialogPhone = data.toString()
            clearInterval(this.countInterver)
            this.countInterver = null
            this.showDialog = true
            this.showCount = true
            this.smsCode = ''
            this.count = 60
            this.countInterver = setInterval(() => {
                if (this.count > 0) {
                    this.count--
                } else {
                    this.showCount = false
                    clearInterval(this.countInterver)
                    this.countInterver = null
                }
            }, 1000)
        },
        // 获取手续费
        async getFeeRate () {
            const { data } = await getFeeRate()
            this.getFee = data.display
        },
        // 再次获取验证码
        async getCodeAgin () {
            // 这里执行获取验证码的接口
            const { data } = await postCashOutSendSms({ bankCardId: this.selectBank.bankCardId })
            this.dialogPhone = data.toString()
            this.showCount = true
            this.count = 60
            this.countInterver = setInterval(() => {
                if (this.count > 0) {
                    this.count--
                } else {
                    this.showCount = false
                    clearInterval(this.countInterver)
                    this.countInterver = null
                }
            }, 1000)
        },
        async closeDialog (action, done) {
            if (action === 'cancel') {
                done()
            } else {
                let codeReg = /^\d{6}$/
                if (!codeReg.test(this.smsCode)) {
                    this.$toast('请正确输入6位验证码')
                    done(false)
                } else {
                    done()
                    this.withdrawAsync()
                    // 这里验证码验证的接口
                    /*const { data } = await postCashOutVerifySms({
                        code: this.smsCode,
                        phoneNumber: this.dialogPhone
                    }).catch(() => {
                        done(false)
                    })
                    if (data === 0) {
                        done()
                        this.withdrawAsync()
                    } else {
                        this.$toast('请正确输入6位验证码')
                        done(false)
                    }*/
                }
            }
        },
        async withdrawAsync () {
            const { companyCode } = this.userInfo
            const { bankCardId, remark } = this.selectBank
            if (parseFloat(this.withdrawAmount) > parseFloat(this.balance)) {
                Toast({
                    message: '余额不足，无法提现',
                    duration: 2000
                })
                setTimeout(() => {
                    this.$router.push({ path: '/b2b/wallet/myWallet' })
                }, 2000)
                return false
            }
            const { data: { status } } = await postWithdraw({
                companyCode,
                amount: this.withdrawAmount,
                mobile: this.dialogPhone,
                receivedAmount: this.receivedAmount,
                serviceFee: this.serviceFee,
                bankCardId,
                remark,
                smsCode: this.smsCode
            })
            this.$router.push({ path: '/b2b/wallet/MyWallet/result', query: { status } })
        },
        selectBankOpt (item) {
            this.selectBank = {
                ...item
            }
            this.bankShow = false
        },
        onBack () {
            if (this.bankShow) {
                this.bankShow = false
            } else {
                this.$router.go(-1)
            }
        },
        details () {
            this.$router.push({ path: '/b2b/wallet/myWallet/walletDetails' })
        },
        pay () {
            this.$router.push({ path: '/b2b/wallet/recharge' })
        },
        /* withDraw () {
            this.$router.push({ path: '/b2b/wallet/withDraw' })
        }, */
        /* onMark () {
            MessageBox.alert('', {
                message: '受第三方要求，充值未消费的金额暂无法进行体现。',
                title: '',
                showConfirmButton: true,
                confirmButtonClass: 'confirmButton',
                confirmButtonText: '确定'
            }).then(action => {
                if (action === 'confirm') {
                }
            })
        }, */
        /* async onCash () {
            this.inputCode()
            if (!(this.msgCode.length && this.withdrawAmount)) {
                return false
            }
            if (!this.myBankOrderNo) {
                Toast({
                    message: '请获取验证码',
                    duration: 2000
                })
                return false
            }
            this.buryPoint(72)
            const { data } = await getPayCenter({
                merchantType: 20,
                outMerchantId: this.userInfo.companyCode
            })
            this.payMent = data
            if (parseFloat(this.withdrawAmount) > parseFloat(this.payMent.balanceAmount)) {
                Toast({
                    message: '余额不足，无法提现',
                    duration: 2000
                })
                setTimeout(() => {
                    this.$router.push({ path: '/b2b/wallet/myWallet' })
                }, 2000)
                return false
            }
            Indicator.open('提交中...')
            await confirmCash({
                msgCode: this.msgCode,
                myBankOrderNo: this.myBankOrderNo
            })
            Indicator.close()
            this.setMoney(this.withdrawAmount)
            this.$router.push({ path: '/b2b/wallet/myWallet/cashSuccess' })
        }, */
        buryPoint (event) {
            this.setBuried({ event: event })
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.getBankinfo()
        this.getBankList()
        this.getFeeRate()
    }
}
</script>
<style lang="scss" scoped>
    .bank{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        background: #ffffff;
        position: relative;
        .bLeft{
            width: 80px;
            height: 80px;
        }
        .bRight{
            padding-left: 24px;
        }
    }
    .cashOut{
        overflow: hidden;
        .icon:after{
            content: '';
            position: absolute;
            right: 24px;
            top: 50px;
            width: 40px;
            height: 40px;
            background: url('../../../../assets/img/b2b/icon_detail.png') no-repeat;
            background-size: 100% 100%;
        }
        .cashInput{
            background: #ffffff;
            .input{
                display: flex;
                justify-content: flex-start;
                align-items: center;
                padding: 32px;
                position: relative;
                .inputLeft{
                    font-size: 48px;
                    color: #FF7A45;
                }
                .inputRight{
                    flex: 1;
                    padding-left: 16px;
                    input::-webkit-input-placeholder{
                        line-height: 120px;
                    }
                    input{
                        line-height: 60px;
                        font-size: 64px;
                        color: #FF7A45;
                        &::-webkit-input-placeholder {
                            color: #C7C7C7;
                            font-size: 32px;
                            transform: translate(0, -10px);
                        }
                        &:-moz-placeholder {
                            color: #C7C7C7;
                            font-size: 32px;
                            transform: translate(0, -10px);
                        }
                        &::-moz-placeholder {
                            color: #C7C7C7;
                            font-size: 32px;
                            transform: translate(0, -10px);
                        }
                        &:-ms-input-placeholder {
                            color: #C7C7C7;
                            font-size: 32px;
                            transform: translate(0, -10px);
                        }
                    }
                }
            }
            .inputCode{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 30px 32px;
                position: relative;
                .inputLeft{
                    font-size: 48px;
                    color: #FF7A45;
                }
                .inputRight{
                    width: 208px;
                    height: 64px;
                    text-align: center;
                    line-height: 64px;
                    border-radius: 64px;
                    &.hide{
                        background: #eaeaea;
                        color: #c7c7c7;
                    }
                    &.show{
                        background: #FF7A45;
                        color: #ffffff;
                    }
                }
            }
            .moneyCode{
                color: #cccccc;
                padding: 40px 32px;
            }
            .money{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 24px 32px;
                .mLeft{
                    position: relative;
                    .weng{
                        position: absolute;
                        right: -50px;
                        top: 0;
                        width: 35px;
                        height: 35px;
                        background: url(../../../../assets/img/b2b/system_help@2x.png) no-repeat;
                        background-size: 100% 100%;
                    }
                }
            }
        }
        .buttom{
            margin: 48px 32px;
            height: 96px;
            line-height: 96px;
            border-radius: 96px;
            text-align: center;
            &.hide{
                background: #eaeaea;
                color: #c7c7c7;
            }
            &.show{
                background: #FF7A45;
                color: #ffffff;
            }
        }
    }
    .dialogBox {
        padding: 48px;
        .head{
            text-align: center;
            .title{
                font-size: 34px;
                color: #333333;
                margin-bottom: 32px;
            }
            .arrivalPrice {
                font-size: 48px;
                color: #FF7A45;
                margin-bottom: 8px;
            }
            .price{
                font-size: 26px;
                color: #8E8E93;
                margin-bottom: 32px;
            }
        }
        .dialogInput {
            display: flex;
            .dialogCode {
                flex: 1;
                box-sizing: border-box;
                padding: 18px 24px;
                border: #EDEDF0 1px solid;
            }
            .codeBtn {
                width: 196px;
                height: 80px;
                font-size: 26px;
                text-align: center;
                line-height: 80px;
                &.countdown {
                    color: #C7C7C7;
                    background-color: #EAEAEA;
                }
                &.getCodeCount {
                    color: #ffffff;
                    background-color: #FF7A45;
                }
            }
        }
        .diologText{
            font-size: 26px;
            color: #8E8E93;
            margin-top: 24px;
        }
    }
</style>
